/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: vipListsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Call Center module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { buildApiUrl, getApiHeaders } from '../../config/api';

/**
 * Shared helpers for VIP Lists (Queue VIP) module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a VIP List in the form.
 * Pattern: /pbx/call-center/vip-lists/new?duplicate={id}
 */
export const getVipListDuplicateUrl = (id: string | number): string =>
  `/pbx/call-center/vip-lists/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given VIP List id.
 */
export const navigateToVipListDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getVipListDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a VIP List by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteVipListById = async (id: string | number): Promise<void> => {
  const response = await fetch(
    buildApiUrl(`/api/telephony/vip-lists/${id}`),
    {
      method: 'DELETE',
      headers: getApiHeaders(),
    },
  );

  if (!response.ok) {
    let message = 'Failed to delete VIP List';
    try {
      const errorData = await response.json();
      if (errorData?.message) {
        message = errorData.message;
      }
    } catch {
      // Ignore JSON parse errors and use default message
    }
    throw new Error(message);
  }
};



